import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Puzzle8Game from '../components/games/Puzzle8Game';
import SudokuGame from '../components/games/SudokuGame';
import TicTacToeGame from '../components/games/TicTacToeGame';
import MindReaderGame from '../components/games/MindReaderGame';
import NumberWizardGame from '../components/games/NumberWizardGame';
import WordPuzzleGame from '../components/games/WordPuzzleGame';
import './GamePage.css';

const GamePage: React.FC = () => {
  const { gameType } = useParams<{ gameType: string }>();
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/');
  };

  const renderGame = () => {
    switch (gameType) {
      case 'mindreader':
        return <MindReaderGame />;
      case 'numberwizard':
        return <NumberWizardGame />;
      case 'puzzle8':
        return <Puzzle8Game />;
      case 'tictactoe':
        return <TicTacToeGame />;
      case 'sudoku':
        return <SudokuGame />;
      case 'wordpuzzle':
        return <WordPuzzleGame />;
      default:
        return (
          <div className="game-not-found">
            <h2>🎮 Game Not Found</h2>
            <p>The game you're looking for doesn't exist.</p>
            <button onClick={handleBackToHome} className="back-button">
              🏠 Back to Home
            </button>
          </div>
        );
    }
  };

  const getGameTitle = () => {
    switch (gameType) {
      case 'mindreader':
        return 'Mind Reader Game';
      case 'numberwizard':
        return 'Number Wizard Game';
      case 'puzzle8':
        return '8-Puzzle Game';
      case 'tictactoe':
        return 'Tic-Tac-Toe Game';
      case 'sudoku':
        return 'Sudoku Game';
      case 'wordpuzzle':
        return 'Word Puzzle Game';
      default:
        return 'Game';
    }
  };

  return (
    <div className="game-page">
      <div className="game-header">
        <button onClick={handleBackToHome} className="back-button">
          ← Back to Games
        </button>
        <h1>{getGameTitle()}</h1>
        <div className="game-actions">
          <button 
            onClick={() => window.open('https://play.google.com/store/apps/details?id=com.sssk.justfun', '_blank')}
            className="download-app-button"
          >
            📱 Get Full App
          </button>
        </div>
      </div>
      
      <div className="game-container">
        {renderGame()}
      </div>
    </div>
  );
};

export default GamePage;
